import { FilterInput } from '@bechtel/sr-types';
import { createContext, FC, PropsWithChildren, useContext } from 'react';

export const PickListFilterContextPrivate = createContext<{
  pickListName: string;
  filter: FilterInput;
} | null>(null);

export const usePickListFilterContext = () => {
  return useContext(PickListFilterContextPrivate);
};

interface PickListFilterContextProps {
  pickListFilter: {
    pickListName: string;
    filter: FilterInput;
  };
}
export const PickListFilterContext: FC<PropsWithChildren<PickListFilterContextProps>> = ({
  children,
  pickListFilter,
}) => {
  return (
    <PickListFilterContextPrivate.Provider value={pickListFilter}>{children}</PickListFilterContextPrivate.Provider>
  );
};
